import React from 'react';
import Navbar from '../../components/Navbar';
import StudyDetail from '../../components/Study/StudyDetail';
import './StudyDetailPage.css';

const StudyDetailPage = () => {
  return (
    <div className="study-detail-page">
      <Navbar />
      <div className="study-detail-content">
        <StudyDetail />
      </div>
    </div>
  );
};

export default StudyDetailPage;
